/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface DesignInstallation
 */
export interface DesignInstallation {
  /**
   *
   * @type {string}
   * @memberof DesignInstallation
   */
  readonly uuid?: string;
  /**
   *
   * @type {Date}
   * @memberof DesignInstallation
   */
  readonly created?: Date;
  /**
   *
   * @type {Date}
   * @memberof DesignInstallation
   */
  readonly updated?: Date;
  /**
   *
   * @type {string}
   * @memberof DesignInstallation
   */
  designInstallationId: string | null;
  /**
   *
   * @type {DesignInstallationInstallationFunctionEnum}
   * @memberof DesignInstallation
   */
  installationFunction: DesignInstallationInstallationFunctionEnum | null;
  /**
   * Point coordinates as string
   * @type {string}
   * @memberof DesignInstallation
   */
  designInstallationPos: string | null;
  /**
   *
   * @type {object}
   * @memberof DesignInstallation
   */
  licensedQuantities: object;
  /**
   *
   * @type {string}
   * @memberof DesignInstallation
   */
  guf: string;
  /**
   *
   * @type {string}
   * @memberof DesignInstallation
   */
  dataOwner: string;
}

/**
 * @export
 */
export const DesignInstallationInstallationFunctionEnum = {
  GeslotenBodemenergiesysteem: "geslotenBodemenergiesysteem",
  OnttrekkingEnRetournering: "onttrekkingEnRetournering",
  Onttrekking: "onttrekking",
  Infiltratie: "infiltratie",
  InfiltratieEnOnttrekking: "infiltratieEnOnttrekking",
  OpenBodemenergiesysteem: "openBodemenergiesysteem",
} as const;
export type DesignInstallationInstallationFunctionEnum =
  (typeof DesignInstallationInstallationFunctionEnum)[keyof typeof DesignInstallationInstallationFunctionEnum];

/**
 * Check if a given object implements the DesignInstallation interface.
 */
export function instanceOfDesignInstallation(value: object): value is DesignInstallation {
  if (
    (!("designInstallationId" in (value as Record<string, any>)) &&
      !("design_installation_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["designInstallationId"] === undefined &&
      (value as Record<string, any>)["design_installation_id"] === undefined)
  )
    return false;
  if (
    (!("installationFunction" in (value as Record<string, any>)) &&
      !("installation_function" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["installationFunction"] === undefined &&
      (value as Record<string, any>)["installation_function"] === undefined)
  )
    return false;
  if (
    (!("designInstallationPos" in (value as Record<string, any>)) &&
      !("design_installation_pos" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["designInstallationPos"] === undefined &&
      (value as Record<string, any>)["design_installation_pos"] === undefined)
  )
    return false;
  if (
    (!("licensedQuantities" in (value as Record<string, any>)) &&
      !("licensed_quantities" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["licensedQuantities"] === undefined &&
      (value as Record<string, any>)["licensed_quantities"] === undefined)
  )
    return false;
  if (!("guf" in value) || value["guf"] === undefined) return false;
  if (
    (!("dataOwner" in (value as Record<string, any>)) &&
      !("data_owner" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["dataOwner"] === undefined &&
      (value as Record<string, any>)["data_owner"] === undefined)
  )
    return false;
  return true;
}

export function DesignInstallationFromJSON(json: any): DesignInstallation {
  return DesignInstallationFromJSONTyped(json, false);
}

export function DesignInstallationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): DesignInstallation {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    created: json["created"] == null ? undefined : new Date(json["created"]),
    updated: json["updated"] == null ? undefined : new Date(json["updated"]),
    designInstallationId: json["design_installation_id"],
    installationFunction: json["installation_function"],
    designInstallationPos: json["design_installation_pos"],
    licensedQuantities: json["licensed_quantities"],
    guf: json["guf"],
    dataOwner: json["data_owner"],
  };
}

export function DesignInstallationToJSON(json: any): DesignInstallation {
  return DesignInstallationToJSONTyped(json, false);
}

export function DesignInstallationToJSONTyped(
  value?: Omit<DesignInstallation, "uuid" | "created" | "updated"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    design_installation_id: value["designInstallationId"],
    installation_function: value["installationFunction"],
    design_installation_pos: value["designInstallationPos"],
    licensed_quantities: value["licensedQuantities"],
    guf: value["guf"],
    data_owner: value["dataOwner"],
  };
}
